import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useAuthStore } from '@/store/authStore';
import { fetchAffiliate, fetchWithdrawals } from '../apis/affiliate';

/** The caller's link and numbers; per user, like the other storefront keys. */
// 403 (not a Family Member) and 404 (no affiliate account) will not change on a retry
const retryUnlessForbidden = (failureCount: number, error: Error) =>
  !(isAxiosError(error) && [403, 404].includes(error.response?.status ?? 0)) && failureCount < 3;

export const useAffiliate = () => {
  const userId = useAuthStore((state) => state.user_id);
  return useQuery({
    queryKey: ['affiliate', userId],
    queryFn: fetchAffiliate,
    retry: retryUnlessForbidden,
  });
};

/** Riwayat, newest first. */
export const useWithdrawals = () => {
  const userId = useAuthStore((state) => state.user_id);
  return useQuery({
    queryKey: ['affiliate-withdrawals', userId],
    queryFn: fetchWithdrawals,
    retry: retryUnlessForbidden,
  });
};
